export const GET_STATISTICS_ALL_USERS = "GET_STATISTICS_ALL_USERS";
export const EDIT_USER = "EDIT_USER";